<template>
    <div>
        <div v-if="$store.state.readyState" class="launches">
            <MissionCard v-for="(mission, index) in $store.getters.missions" :key="index" :mission="mission"/>
        </div><!-- /.launches -->
    </div>
</template>

<script>

import MissionCard from '@/components/MissionCard'

export default {
    name: 'MissionList',
    components: {
        MissionCard,
    },
    data() {
        return {
            apiUrl: 'https://api.spacexdata.com/v3/missions'
        }
    },
    methods: {
        
    },
    computed: {
        hasMissions() {
            return this.$store.state.missions || []
        }
    }
}
</script>

<style>

</style>

  